export default __webpack_public_path__ + "static/media/804.76b6847c.png";